import { render, staticRenderFns } from "./InviteJoinResult.vue?vue&type=template&id=f55e0574&scoped=true"
import script from "./InviteJoinResult.vue?vue&type=script&lang=js"
export * from "./InviteJoinResult.vue?vue&type=script&lang=js"
import style0 from "./InviteJoinResult.vue?vue&type=style&index=0&id=f55e0574&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55e0574",
  null
  
)

export default component.exports